import { FC } from 'react'

import { AssignmentRendererProps } from './AssignmentRenderer.types'
import { RendererQueryState, UploadedFilesSection } from '../common'
import { ConsumptionCertificateSection } from './shared/ConsumptionCertificateSection.component'
import { useAssignmentDetailDrawerWorkspaceId } from '../AssignmentDetailDrawer.context'
import { useGetConsumptionCertificateDetails } from 'dataQueries/assignmentDetails.query'

/**
 * Assignment detail renderer for consumption certificate products.
 * Handles ProductType.CONSUMPTION_CERTIFICATE assignments.
 */
export const ConsumptionCertificateDetailsRenderer: FC<AssignmentRendererProps> = ({ assignment }) => {
  const workspaceId = useAssignmentDetailDrawerWorkspaceId()
  const { data, isLoading, isError, refetch } = useGetConsumptionCertificateDetails(assignment.id, workspaceId)

  return (
    <RendererQueryState assignmentId={assignment.id} isLoading={isLoading} isError={isError} onRetry={refetch}>

      {!!data &&
        <ConsumptionCertificateSection data={data} />
      }

      <UploadedFilesSection assignmentId={assignment.id} />

    </RendererQueryState>
  )
}
